module.exports = __webpack_public_path__ + "media/images/ready/icon-phone-01ceba522b51c47de64538a39ea1ab1a.svg";